<div *ngIf="!showRequest">
    <div>
        <h2 *ngIf="!isReadOnly" class="sectionTitle">{{'FRONT_USER.PROFILE_FORM.PROFILEFORM' | translate }}</h2>
        <h2 *ngIf="isReadOnly" class="sectionTitle">{{'FRONT_USER.PROFILE_FORM.USER_DETAILS' | translate }}</h2>

    </div>
</div>

<div *ngIf="!showRequest">
    <form [formGroup]="profileForm" >
        <div class="form-container">

            <div *ngIf="isReadOnly" class="form-group">
                <label for="RegisterTypeId">{{'FRONT_USER.REGISTRATION_FORM.REGISTRATION_TYPE'| translate}}</label>
                <span class="red"> *</span>
                <select formControlName="RegisterTypeId" id="RegisterTypeId" name="RegisterTypeId" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted || (f.RegisterTypeId?.dirty && f.RegisterTypeId?.errors) }">
                    <option [value]='null' selected>
                        {{'FRONT_USER.REGISTRATION_FORM.REGISTRATION_TYPE_CHOOSE' | translate}}
                    </option>
                    <ng-container *ngFor="let type of registrationTypes">
                        <option *ngIf="displayedLang==Languages.English" [value]="type.Id">
                            {{type.NameEN}}
                        </option>
                        <option *ngIf="displayedLang==Languages.Arabic" [value]="type.Id">
                            {{type.NameAR}}
                        </option>
                    </ng-container>
                </select>
            </div>

            <div *ngIf="isReadOnly" class="form-group">
                <label for="PortalUserTypeId">{{'FRONT_USER.REGISTRATION_FORM.USER_TYPE' | translate}}</label>
                <span class="red"> *</span>
                <select formControlName="PortalUserTypeId" id="PortalUserTypeId" name="PortalUserTypeId"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submitted ||(f.PortalUserTypeId?.dirty && f.PortalUserTypeId?.errors) }">
                    <option [value]="''" selected>
                        {{'FRONT_USER.REGISTRATION_FORM.USER_TYPE_CHOOSE' | translate}}
                    </option>
                    <ng-container *ngFor="let userType of portalUserTypes">
                        <option *ngIf="displayedLang==Languages.English" [value]="userType.Id">
                            {{userType.NameEN}}
                        </option>
                        <option *ngIf="displayedLang==Languages.Arabic" [value]="userType.Id">
                            {{userType.NameAR}}
                        </option>
                    </ng-container>
                </select>
            </div>

            <div *ngIf="!isConfirmed" class="form-group">
                <label for="email">{{'FRONT_USER.PROFILE_FORM.EMAIL' | translate}}</label>
                <span class="red"> *</span>
                <input type="text" id="email" name="email" formControlName="email" class="form-control"
                  (keydown.space)="$event.preventDefault();"  [ngClass]="{ 'is-invalid': submitted && f.email?.errors }" />
                <div class="blue italic">
                    <span>
                        {{'FRONT_USER.PROFILE_FORM.EMAIL_INVALID_ERROR' | translate}}
                    </span>
                </div>
                <div *ngIf="submitted ||(f.email?.dirty&& f.email?.errors)" class="red ">
                    <div *ngIf="f.email?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

                    <div *ngIf="f.email?.errors?.pattern">
                        {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                    </div>
                </div>
            </div>


            <div class="form-group">
                <label for="fullName">{{'FRONT_USER.REGISTRATION_FORM.FULL_NAME' | translate}}</label>
                <span class="red"> *</span>
                <input type="text" id="fullName" name="fullName" formControlName="fullName" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.fullName?.errors }" />
                <div *ngIf="submitted ||(f.fullName?.dirty && f.fullName?.errors)" class="red ">
                    <div *ngIf="f.fullName?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                </div>

            </div>


            <div class="form-group">
                <label for="country">{{'FRONT_USER.REGISTRATION_FORM.COUNTRY' | translate}}</label>
                <span class="red"> *</span>
                <select formControlName="country" id="country" name="country" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.country?.errors }">
                    <ng-container *ngFor="let count of Countries">
                        <option *ngIf="displayedLang==Languages.English" [value]="count.Id">
                            {{count.NameEN}}
                        </option>
                        <option *ngIf="displayedLang==Languages.Arabic" [value]="count.Id">
                            {{count.NameAR}}
                        </option>
                    </ng-container>

                </select>
                <div *ngIf="submitted ||(f.country?.dirty && f.country?.errors)" class="red ">
                    <div *ngIf="f.country?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |translate}}
                    </div>
                </div>
            </div>

           <!-- <div class="form-group">
                <label for="mobile">{{'FRONT_USER.REGISTRATION_FORM.MOBILE' |translate}}</label>
                <span class="red"> *</span>

                <ngx-intl-tel-input [enableAutoCountrySelect]="true" [enablePlaceholder]="true" id="mobile"
                    name="mobile" formControlName="mobile"></ngx-intl-tel-input>



                <div *ngIf="submitted ||(f.mobile?.dirty && f.mobile?.errors)" class="red ">
                    <div *ngIf="f.mobile?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' |translate}}</div>
                    <div *ngIf="f.mobile?.errors?.validatePhoneNumber">
                        {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}</div>

                </div>
            </div>-->

            <div class="form-group">
              <label for="mobile">{{ 'FRONT_USER.REGISTRATION_FORM.MOBILE' | translate}}</label>
              <span class="red"> *</span>
              <input type="text" formControlName="mobile" name="mobile" class="form-control" />
              <div *ngIf="submitted ||( f.mobile?.touched && f.mobile?.dirty  && f.mobile?.errors)"
              class="red">
              <div *ngIf="f.mobile?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' |translate}}
              </div>
              </div>
              <div class="red"
                  *ngIf="f.mobile?.touched &&f.mobile?.dirty && f.mobile?.errors?.validatePhoneNumber">
                  {{'FRONT_USER.REGISTRATION_FORM.VALID_PHONE_NUMBER' | translate}}
              </div>
            </div>

            <!-- <div *ngIf="portalProfile.Address== null || portalProfile.Address ==undefined"> -->
            <div class="form-group">
                <label for="address">{{'FRONT_USER.REGISTRATION_FORM.ADDRESS' | translate}}</label>
                <input type="text" formControlName="address" id="address" name="address" class="form-control" />
            </div>
            <!-- </div> -->

            <!-- <div *ngIf="portalProfile.Fax== null || portalProfile.Fax ==undefined"> -->
            <div class="form-group">
                <label for="fax">{{ 'FRONT_USER.REGISTRATION_FORM.FAX' | translate}}</label>
                <input type="text" formControlName="fax" id="fax" name="fax" class="form-control" />
                <div *ngIf="submitted ||(f.fax?.dirty &&f.fax?.errors)" class="red ">
                    <div *ngIf="f.fax?.errors?.pattern">
                        {{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                </div>
            </div>
            <!-- </div> -->

            <!-- <div *ngIf="portalProfile.Organization== null || portalProfile.Organization ==undefined"> -->
            <div class="form-group">
                <label for="organization">{{ 'FRONT_USER.REGISTRATION_FORM.ORGANIZATION' | translate}}</label>
                <input type="text" id="organization" name="organization" formControlName="organization"
                    class="form-control" />
            </div>
            <!-- </div> -->

        </div>
        <p *ngIf="!isReadOnly" class="btns-holder">
            <button Confirmation  (confirmationClick)="onSubmit()"  class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.PROFILE_FORM.COMPLETE' | translate}}</button>
            <a routerLink="/workspace" class="btn btn-link SCAcustomBtn">{{ 'FRONT_USER.CANCEL' | translate}}</a>

        </p>
    </form>
</div>
<!-- Confirmation -->
<div *ngIf="showRequest  && !isErrorMessage" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p *ngIf="!showConfirmMail">{{ 'FRONT_USER.SUCCESS_MESSAGES.COMPLETE_ACCOUNT' | translate }}</p>

        <p *ngIf="showConfirmMail">{{ 'FRONT_USER.SUCCESS_MESSAGES.CONFIRM_EMAIL_ACCOUNT' | translate }}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
                {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>

        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
                {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
</div>
